import { action } from '@ember/object';
import Component from '@glimmer/component';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import FormSelectComponent from 'webapp/components/form/select';
import ToolTipComponent from 'webapp/components/tool-tip';

interface Args {
	name: string;
	extraClass?: string;
	theme?: string;
	size?: string;
}

export default class RestrictedDropdownComponent extends Component<Args> {
	restricted = 1;

	extraClass = this.args.extraClass || 'right';

	restrictedOptions = [{ value: 1, label: 'Restricted access' }];

	tooltipText = "You don't have edit permissions to the selected data source.";

	@action
	doNothing() {
		// as the name says.
	}
	<template>
		<div class={{this.extraClass}}>
			<FormSelectComponent
				name={{@name}}
				@selected={{this.restricted}}
				@options={{this.restrictedOptions}}
				@onChange={{this.doNothing}}
				@tooltipOnSelectionFromProperty=""
				@size={{@size}}
				@theme={{@theme}}
				@isDisabled={{true}}
			/>

			<div class="icon-ct">
				<CommonUiIconComponent @name="Lock" @size="sm" />
				<ToolTipComponent @text={{this.tooltipText}} />
			</div>
		</div>
	</template>
}
